module.exports = __webpack_public_path__ + "static/Website Banners-04-96602ca721b755c7c6e6d644917aa4e6.png";